import { render } from "./HomeSoluciones.vue?vue&type=template&id=9f7fc4fa&scoped=true"
import script from "./HomeSoluciones.vue?vue&type=script&lang=js"
export * from "./HomeSoluciones.vue?vue&type=script&lang=js"

import "./HomeSoluciones.vue?vue&type=style&index=0&id=9f7fc4fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f7fc4fa"]])

export default __exports__